import list from 'src/modules/quizQuestion/list/quizQuestionListReducers';
import form from 'src/modules/quizQuestion/form/quizQuestionFormReducers';
import view from 'src/modules/quizQuestion/view/quizQuestionViewReducers';
import destroy from 'src/modules/quizQuestion/destroy/quizQuestionDestroyReducers';
import unarchive from 'src/modules/quizQuestion/unarchive/quizQuestionUnarchiveReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  unarchive,
});
